import type {
  MarketId,
  MarketLevelCompoundMarketTemplateColumnClientConfig
} from '@ps/isp-web-services-types';
import React from 'react';

import TableColumnTable from '../../components/TableColumnTable/TableColumnTable';

interface Props extends MarketLevelCompoundMarketTemplateColumnClientConfig {
  marketIds: (MarketId | null)[];
}

const TableColumn: React.FC<Props> = (props) => <TableColumnTable {...props} />;

export default TableColumn;
